import Main from '@/views/main.vue'

import {expenselistMenuRouter} from './expenselist'

const expenseMenuRouter = {
  has: 'expenseStatement',
  path: '/',
  icon: 'android-people',
  name: 'expenseMenuRouter',
  title: '费用结算单',
  component: Main,
  children: [
    ...expenselistMenuRouter
  ]
}

export {expenseMenuRouter}



// WEBPACK FOOTER //
// ./src/router/expense/index.js